module.exports = __webpack_public_path__ + "media/npc_dota_hero_batrider.9a466fa8.webm";